import { createSubjects } from "@openauthjs/openauth/subject";
import { object, optional, picklist, string } from "valibot";
export { TEAM_MEMBER_ROLES, TEAM_MEMBER_ROLE_RANK, isTeamMemberRole, permitsCashierCapability } from "./team-roles.js";
export const subjects = createSubjects({
    user: object({
        id: string(),
        phone: string(),
        role: picklist(["admin", "user"]),
        defaultTeamId: optional(string()),
    }),
});
export function normalizeColombianPhone(input) {
    const digits = input.replace(/\D/g, "");
    if (digits.length === 10 && digits.startsWith("3"))
        return "57" + digits;
    if (digits.length === 12 && digits.startsWith("57") && digits[2] === "3")
        return digits;
    return null;
}
export async function deriveUserId(normalizedPhone) {
    const data = new TextEncoder().encode(normalizedPhone);
    const hash = await crypto.subtle.digest("SHA-256", data);
    return Array.from(new Uint8Array(hash).slice(0, 12))
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("");
}
export { LOCAL_DEV_ADMIN, LOCAL_DEV_TENANT, LOCAL_DEV_COMPANY, LOCAL_DEV_SEGOVIA, LOCAL_DEV_COMPANIES, LOCAL_DEV_TEAM_ID, LOCAL_DEV_COMPANY_ID, } from "./local-dev-identities.js";
export { CUSTOM_ROLE_BASES, TEAM_PERMISSION_MODULES, templatePermissions, normalizeTeamPermissions, permitsTeamPermission, customRoleHasDocumentAccess } from "./team-permissions.js";
//# sourceMappingURL=index.js.map